import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import user from './modules/admin/user'
import role from './modules/admin/role'
import tab from './modules/admin/tab'
import company from './modules/admin/company'
import dashboard from './modules/admin/dashboard'
import dealer from './modules/admin/dealer'
import zone from './modules/admin/zone'
import branch from './modules/admin/branch'
import employee from './modules/admin/employee'
import dealercontact from './modules/admin/dealercontact'
import manufacturer from './modules/admin/manufacturer'
import manufacturerModelModule from './modules/admin/manufacturer-model'

import concept from './modules/casis/concept'
import capacity from './modules/casis/capacity'
import figure from './modules/casis/figure'
import fee from './modules/casis/fee'

import sale from './modules/cems/sale'
import country from './modules/cems/country'
import quiz from './modules/cems/quiz'


import category from './modules/extranet/category'
import document from './modules/extranet/document'

import agreement from './modules/tracing/agreement'
import workshopinfo from './modules/tracing/workshopinfo'

import department from './modules/preferences/department'
import province from './modules/preferences/province'
import district from './modules/preferences/district'
import generaltype from './modules/preferences/generaltype'
import generaltypevalue from './modules/preferences/generaltypevalue'
import configuration from './modules/preferences/configuration'

import transaction from './modules/transaction/offices'
import dashboardTransactionModule from './modules/transaction/dashboard-transaction'
import dailyModule from './modules/transaction/daily';


const store = new Vuex.Store({
    state: {
        //
        //loading: boolean
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        app,
        session,
        user,
        role,
        tab,
        company,
        dashboard,
        dealer,
        zone,
        branch,
        employee,
        dealercontact,
        manufacturer,
        'manufacturer-models': manufacturerModelModule,

        concept,
        capacity,
        figure,
        fee,

        sale,
        country,
        quiz,

        category,
        document,

        agreement,
        workshopinfo,

        department,
        province,
        district,
        configuration,
        generaltype,
        generaltypevalue,

        transaction,
        dashboardTransactionModule,
        dailyModule,
    }
});

export default store;